export default __webpack_public_path__ + "static/media/profile.a73dc573.jpg";